function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { classnames } from '@bydesign-ui/utils';
import React, { useState } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { RateCharItem } from './RateCharItem';
export function Rate(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      value = props.value,
      _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? 0 : _props$defaultValue,
      _props$allowHalf = props.allowHalf,
      allowHalf = _props$allowHalf === void 0 ? false : _props$allowHalf,
      _props$allowClear = props.allowClear,
      allowClear = _props$allowClear === void 0 ? false : _props$allowClear,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$count = props.count,
      count = _props$count === void 0 ? 5 : _props$count,
      _props$character = props.character,
      character = _props$character === void 0 ? '☆' : _props$character,
      onChange = props.onChange,
      onHoverChange = props.onHoverChange,
      children = props.children,
      className = props.className,
      tooltips = props.tooltips,
      _props$activeColor = props.activeColor,
      activeColor = _props$activeColor === void 0 ? '#FAAD15' : _props$activeColor,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? '#999' : _props$textColor,
      extra = _objectWithoutProperties(props, ["size", "value", "defaultValue", "allowHalf", "allowClear", "disabled", "count", "character", "onChange", "onHoverChange", "children", "className", "tooltips", "activeColor", "textColor"]);

  var _useState = useState(value || defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      starValue = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      hoverValue = _useState4[0],
      setHoverValue = _useState4[1];

  var hanldeClick = function hanldeClick(index) {
    if (disabled) {
      return;
    }

    var realValue = allowHalf ? hoverValue : index + 1;
    realValue = allowClear && index + 1 === starValue ? 0 : realValue;
    setValue(realValue);
    onChange && onChange(realValue);
  };

  var handleHover = function handleHover(isFull, index) {
    if (isFull) {
      setHoverValue(index + 1);
      setValue(index + 1);
      onHoverChange && onHoverChange(index + 1);
    } else {
      setHoverValue(index + 0.5);
      setValue(index + 0.5);
      onHoverChange && onHoverChange(index + 0.5);
    }
  };

  var wrapCls = classnames(usePrefixCls('rate-wrapper'), className);
  var cls = classnames(usePrefixCls('rate', {
    size: size
  }), className);
  var textCls = classnames(usePrefixCls('rate-text', {
    size: size
  }));
  var innerRender = Array(count).fill(0).map(function (item, index) {
    var tooltip = tooltips && tooltips.length ? tooltips[index] : '';
    var diff = starValue - index >= 1 ? 1 : starValue - index > 0 ? starValue - index : 0;
    return React.createElement(RateCharItem, {
      allowHalf: allowHalf,
      key: index,
      onHover: function onHover(isFull) {
        return handleHover(isFull, index);
      },
      value: diff,
      tooltip: tooltip,
      disabled: disabled,
      character: character,
      activeColor: activeColor,
      onClick: function onClick() {
        return hanldeClick(index);
      }
    });
  });
  return React.createElement("div", Object.assign({
    className: wrapCls
  }, extra), React.createElement("div", {
    className: cls
  }, innerRender), tooltips && tooltips.length && React.createElement("div", {
    className: textCls,
    style: {
      color: textColor
    }
  }, tooltips[Math.ceil(starValue) - 1]), children);
}